

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as Types from '../../mini'
import * as MicroUtils from '../../utils'
import { env } from '@ivy/fts/envInfo/envInfo'
import { translateUrl } from '@/api/goods/statistics'

@Component({})
export default class Button extends Vue {
  @Prop() data: any
  @Prop() uploadEvent: any

  get type() {
    return this.data.showType
  }

  get wrapBg() {
    let position = ''
    if (!this.data.inGroup) {
      let buttons = (this.$parent as any).previewComps.filter(
        r => r.type === 'button' && r.position === 'bottom'
      )
      let index = buttons.findIndex(r => r._id === this.data._id)
      let bottom = 0
      if (index !== -1) {
        let pixel = 61
        bottom = (buttons.length - index - 1) * pixel
      }
      if (this.data.position === 'bottom') {
        position = `position: fixed;
        bottom: ${this.convertPxToVw(bottom)}vw;
      `
      }
    }
    let margin = this.data.showType === 'text' ? 0 : this.data.margin
    return `
      background: ${this.data.bgColor};
      padding: 0 ${this.convertPxToVw(margin)}vw;
      ${position}
    `
  }

  get buttonStyle() {
    return `
      background: ${this.data.color};
      color: ${this.data.textColor};
      font-size: ${this.convertPxToVw(this.data.fontSize)}vw;
    `
  }

  get imgType() {
    return `
      object-fit: ${this.data.filling};
    `
  }

  get transform() {
    if (this.data.fontSize < 12) {
      return `transform: scale(${this.data.fontSize / 12})`
    }
    return ''
  }

  mounted() {
    if (this.data.position === 'bottom') {
      try {
        this.$el.parentElement.setAttribute('type', 'float')
      } catch {}
    }
  }

  convertPxToVw(pixel) {
    const viewportWidth = 375
    return (100 / viewportWidth) * parseInt(pixel)
  }

  async goDetail() {
    let translateRes = await translateUrl(this.data.jumpUrl)
    let name = this.data.text
    // 微页面组件内容点击埋点
    await this.uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: this.data.title,
        ContentName: this.type === 'text' ? name : '图片',
        JumpType: translateRes.jumpType,
        JumpContentName: translateRes.jumpName,
        JumpContentID: translateRes.jumpId,
        isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName_ContentName'],
        ['p3', 'isTabPage'],
        [
          'p4',
          `${
            this.data.jumpUrl ? 'JumpType_JumpContentID_JumpContentName' : ''
          }`,
        ],
      ]
    )
    if (!this.data.jumpUrl) return
    MicroUtils.goLink(this.data.jumpUrl, env)
  }
}
